export namespace STALE_TIME {
  export const MIN_5 = 5 * 60 * 1000
  export const MIN_30 = 30 * 60 * 1000
}
